import { createRouter, createWebHistory } from 'vue-router';
import demoComponents from './demo-components';
import { loadingBar } from 'heyui';
import utils from '@common/utils';
import { ensureDesktopAuth } from '@common/desktop-auth';
import Request from '@common/request';
import LoginPage from '@components/login/index';

const routeConfig = {
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: LoginPage
    },
    {
      path: '/',
      component: () => import('@components/app/app-frame'),
      children: [
        {
          path: '',
          redirect: { name: 'SettlementProcess' }
        },
        {
          path: '/home',
          name: 'Home',
          redirect: { name: 'SettlementProcess' }
        },
        {
          path: '/material-check',
          name: 'MaterialCheck',
          component: () => import('@/views/material-check/MaterialCheck.vue'),
          meta: { title: '结算清单核查', icon: 'icon-paper' }
        },
        {
          path: '/settlement-process',
          name: 'SettlementProcess',
          component: () => import('@/views/settlement-process/SettlementProcess.vue'),
          meta: { title: '结算清单处理', icon: 'icon-paper-stack' }
        },
        {
          path: '/inventory-import',
          name: 'InventoryImport',
          component: () => import('@/views/inventory-import/InventoryImport.vue'),
          meta: { title: '物资导入模板', icon: 'icon-box' }
        },
        {
          path: '/cji3-cost',
          name: 'Cji3CostAnalysis',
          component: () => import('@/views/cji3-cost/Cji3CostAnalysis.vue'),
          meta: { title: 'CIi3成本分析', icon: 'icon-bar-graph-2' }
        },
        {
          path: '/qrcode-parse',
          name: 'QrcodeParse',
          component: () => import('@/views/qrcode-parse/QrcodeParse.vue'),
          meta: { title: '二维码解析', icon: 'icon-qrcode' }
        },
        {
          path: '/excel-split',
          name: 'ExcelSplit',
          component: () => import('@/views/excel-split/ExcelSplit.vue'),
          meta: { title: 'Excel表格拆分', icon: 'icon-grid-2' }
        },
        {
          path: '/file-transfer',
          name: 'FileTransfer',
          component: () => import('@/views/file-transfer/FileTransfer.vue'),
          meta: { title: '文件传输', icon: 'icon-share' }
        },
        {
          path: '/settlement-archive',
          name: 'SettlementArchive',
          component: () => import('@/views/system/ArchiveQuery.vue'),
          meta: { title: '归档查询', icon: 'icon-cog' }
        },
        {
          path: '/settlement-archive/:id',
          name: 'SettlementArchiveDetail',
          component: () => import('@/views/system/ArchiveQuery.vue'),
          meta: { title: '结算清单明细', menuKey: 'SettlementArchive' }
        },
        {
          path: '/system-error',
          name: 'SystemError',
          component: () => import('@components/error-pages/500'),
          meta: { title: '系统错误' }
        },
        {
          path: '/permission-error',
          name: 'PermissionError',
          component: () => import('@components/error-pages/403'),
          meta: { title: '权限错误' }
        },
        {
          path: '/notfound-error',
          name: 'NotfoundError',
          component: () => import('@components/error-pages/404'),
          meta: { title: '页面找不到' }
        },
        {
          path: '/authorization',
          name: 'Authorization',
          component: () => import('@components/management/authorization'),
          meta: { title: '权限管理' }
        },
        {
          path: '/users',
          name: 'Users',
          component: () => import('@components/management/users'),
          meta: { title: '用户管理' }
        },
        {
          path: '/access-log',
          name: 'AccessLog',
          component: () => import('@/views/system/AccessLog.vue'),
          meta: { title: '访问日志' }
        },
        ...demoComponents,
        {
          path: '/:pathMatch(.*)*',
          name: 'CommonNotfoundError',
          component: () => import('@components/error-pages/404'),
          meta: { title: '页面找不到' }
        }
      ]
    }
  ]
};

const router = createRouter({
  history: createWebHistory(),
  routes: routeConfig.routes
});

let isFirstRouter = true;

router.beforeEach(async (to, from, next) => {
  if (to.name !== 'Login') {
    loadingBar.start();
  }
  if (to.meta && to.meta.title) {
    document.title = to.meta.title + ' - 管理应用';
  } else if (to.name === 'Login') {
    document.title = '个人工作记录';
  } else {
    document.title = '管理系统';
  }

  let token = utils.getLocal('token');
  if (!token && to.name !== 'Login') {
    await ensureDesktopAuth();
    token = utils.getLocal('token');
  }

  if (to.name === 'Login') {
    if (token) {
      next({ name: 'SettlementProcess', replace: true });
      return;
    }
    isFirstRouter = false;
    next();
    return;
  }

  if (!token) {
    next({ name: 'Login', replace: true });
    return;
  }

  isFirstRouter = false;
  next();
});

router.afterEach((to) => {
  if (to.name !== 'Login') {
    loadingBar.success();
  }
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  let layoutContent = document.querySelector('.h-layout-content');
  if (layoutContent) {
    layoutContent.scrollTop = 0;
  }
  if (window._hmt) {
    window._hmt.push(['_trackPageview', window.location.pathname]);
  }
  if (to.name && to.name !== 'Login' && utils.getLocal('token')) {
    Request.Access.report({
      path: to.fullPath || to.path || '/',
      page: (to.meta && to.meta.title) || String(to.name),
    }).catch(() => {});
  }
});

export default router;
